import _implicitStylesheets from "./recentItemOption.css";
import _implicitScopedStylesheets from "./recentItemOption.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"} class="item-img${0}"${"a0:alt"}${2}>`;
const $fragment2 = parseFragment`<img src="./assets/images/listing-default-icon.svg" class="item-img${0}"${"a0:alt"}${2}>`;
const $fragment3 = parseFragment`<span data-testid="recent-item-text" class="recent-item-text${0}"${2}>${"t1"}</span>`;
const stc0 = {
  "listed-recent-item": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "data-item": $cmp.recentItem.listing.name,
      "data-testid": "recent-item"
    },
    key: 0
  }, [!$cmp.shouldShowDefaultLogo ? api_static_fragment($fragment1, 2, [api_static_part(0, {
    on: {
      "error": _m1 || ($ctx._m1 = api_bind($cmp.showDefaultLogo))
    },
    attrs: {
      "src": $cmp.logo,
      "alt": $cmp.logoAlt
    }
  }, null)]) : null, $cmp.shouldShowDefaultLogo ? api_static_fragment($fragment2, 4, [api_static_part(0, {
    attrs: {
      "alt": $cmp.logoAlt
    }
  }, null)]) : null, api_static_fragment($fragment3, 6, [api_static_part(1, null, api_dynamic_text($cmp.recentItem.listing.name))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3tmogc2oj0b";
tmpl.legacyStylesheetToken = "undefined-_recentItemOption";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
